var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBmp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 34.643V5.357C8 4.608 8.624 4 9.393 4h12.179L32 14.16v20.483c0 .749-.624 1.357-1.393 1.357H9.393C8.624 36 8 35.392 8 34.643z",
    fill: "#C13D27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.574 4 10.428 10.16h-9.035c-.769 0-1.393-.608-1.393-1.357V4z",
    fill: "#D6B5B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.883 31.734h2.316c1.203 0 1.926-.601 1.926-1.59v-.007c0-.735-.508-1.274-1.27-1.356v-.066c.555-.094.989-.621.989-1.207V27.5c0-.863-.637-1.402-1.696-1.402h-2.265v5.636zm2.062-4.922c.649 0 1.028.31 1.028.84v.008c0 .547-.403.836-1.176.836h-1.04v-1.683h1.188zm.028 2.352c.824 0 1.257.313 1.257.918v.008c0 .605-.418.93-1.207.93h-1.265v-1.856h1.215zm3.277 2.57h.797v-4.136h.062l1.653 4.136h.648l1.656-4.136h.059v4.136h.797v-5.636h-1.008l-1.797 4.496h-.062l-1.797-4.496H17.25v5.636zm7.086 0h.875V29.81h1.32c1.106 0 1.871-.754 1.871-1.856v-.008c0-1.105-.765-1.847-1.87-1.847h-2.196v5.636zm1.977-4.898c.757 0 1.199.41 1.199 1.113v.008c0 .707-.442 1.117-1.2 1.117h-1.101v-2.238h1.102z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmp);
export default __webpack_public_path__ + "static/media/bmp.1c80a0f40c57a4fa008a6141a64ee8a5.svg";
export { ForwardRef as ReactComponent };